"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("utils/constants");
const gridHeight = {
    height: 'calc(100vh - 290px)'
};
const modalContainer = theme => ({
    padding: 24,
    width: 390,
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const modalConfirmContainer = {
    padding: 10,
    paddingTop: 0,
    width: 432,
    height: 376,
};
const modalHeader = {
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 'bold',
    alignItems: 'center',
    marginBottom: 24
};
const itemAdd = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20
};
const inputContainerItem = {
    width: 200
};
const inputItem = {
    height: 27,
    borderRadius: 5
};
const buttonSave = theme => ({
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    backgroundColor: theme === 'light' ? constants_1.color.redDark : constants_1.color.buttonDark,
    height: 40,
    width: 84,
    borderRadius: 10,
});
const buttonDelete = {
    padding: '0 5px',
    display: 'flex',
    fontSize: 'large',
    fontWeight: 'normal',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: constants_1.color.white,
    backgroundColor: constants_1.color.redDark,
    height: 35,
    width: 65,
    borderRadius: 10
};
const modalTitle = {
    margin: 0,
    fontSize: 20,
};
const dropdownStyle = theme => ({
    color: theme === 'dark' ? constants_1.color.white : constants_1.color.black,
    borderColor: theme === 'dark' ? constants_1.color.white : constants_1.color.borderGrey,
    backgroundColor: theme === 'dark' ? constants_1.color.backgroundDark : constants_1.color.white,
});
const cardGridStyle = theme => ({
    borderRadius: '10px',
    padding: '10px',
    backgroundColor: theme === 'light' ? '#FFFFFF' : '#272936'
});
const button = (color) => ({
    height: 40,
    display: 'flex',
    borderRadius: 8,
    width: 'fit-content',
    padding: '12px 20px',
    alignItems: 'center',
    backgroundColor: color,
});
const buttonFont = {
    fontSize: '16px',
    fontWeight: 500,
    margin: 0,
    marginLeft: 4
};
const buttonWrapper = {
    display: 'grid',
    columnGap: '12px',
    marginBottom: '24px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gridTemplateColumns: 'auto auto',
};
exports.default = {
    button,
    itemAdd,
    inputItem,
    gridHeight,
    modalTitle,
    buttonSave,
    buttonFont,
    modalHeader,
    buttonDelete,
    dropdownStyle,
    cardGridStyle,
    buttonWrapper,
    modalContainer,
    inputContainerItem,
    modalConfirmContainer,
};
